import { RPCs } from "../../services/rpc.js";
import { useRPC } from "../../hooks/useRPC/index.js";
import { useRPCServerEventHandler } from "../../hooks/useRPCServerEventHandler/index.js";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/RecordsFieldOptionsConfig/context.tsx
var RecordsFieldOptionsConfigContext = createContext(null);
function RecordsFieldOptionsConfigProvider({ children }) {
	const [config, setConfig] = useState(void 0);
	const { call, data, isCalling } = useRPC(RPCs.Records.GetRecordsFieldOptionsConfig.v1, {});
	useEffect(() => {
		if (data?.recordsFieldOptionsConfig) setConfig(data.recordsFieldOptionsConfig);
	}, [data]);
	useRPCServerEventHandler("RecordsFieldOptionsConfigUpdated", (_event, payload) => {
		if (payload?.recordsFieldOptionsConfig) setConfig(payload.recordsFieldOptionsConfig);
	});
	const value = useMemo(() => ({
		config,
		isLoading: isCalling && !config,
		refresh: () => {
			call();
		},
		setConfig
	}), [
		config,
		isCalling,
		call
	]);
	return /* @__PURE__ */ jsx(RecordsFieldOptionsConfigContext.Provider, {
		value,
		children
	});
}
function useRecordsFieldOptionsConfigContext() {
	const ctx = useContext(RecordsFieldOptionsConfigContext);
	if (!ctx) throw new Error("useRecordsFieldOptionsConfigContext must be used inside <RecordsFieldOptionsConfigProvider>");
	return ctx;
}
function useRecordsFieldOptionsConfig() {
	return useRecordsFieldOptionsConfigContext().config;
}
//#endregion
export { RecordsFieldOptionsConfigProvider, useRecordsFieldOptionsConfig, useRecordsFieldOptionsConfigContext };

//# sourceMappingURL=context.js.map